/**
 * Created by snikic on 13/03/17.
 */

define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        lpUtils = require("utils/lpUtils"),
        agentLEManager = require('web-agent-utils/agentLEManager'),
        ChatNotificationsController = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatNotificationsController = Marionette.Controller.extend({

            initialize: function (options) {
                logger.debug("initialize : entered", "NotificationController.initialize");
                this._chatChannel = options.chatChannel;
                this._contextModel = options.contextModel;
                this._chatTabState = CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST;
                this._iframeState = CP_CONST.CONVERSATION_IFRAME_STATE.NONE;
                this._bindEvents();
            },

            _bindEvents: function () {
                var cVent = this._chatChannel.vent;
                this.listenTo(cVent, "messaging:newChatMessageArrived", this._handleNewChatMessage);
                this.listenTo(cVent, "messaging:newMessagingMessageArrived", this._handleNewMessagingMessage);
                this.listenTo(cVent, "cpChatUI:display:messagingFrame", function(){
                    this._iframeState = CP_CONST.CONVERSATION_IFRAME_STATE.MESSAGING;
                }, this);
                this.listenTo(cVent, "cpChatUI:display:chatFrame",function(skillName){
                    this._iframeState = CP_CONST.CONVERSATION_IFRAME_STATE.CHAT;
                    this._currentChatSKill = skillName || this._currentChatSKill;
                    this._resetChatCounter(skillName);
                }, this);

                this.listenTo(cVent, "cpChatUI::layout:contacts:show", function( ){this._chatTabState = CP_CONST.CHAT_TAB_STATES.CONTACTS_LIST;}, this);
                this.listenTo(cVent, "cpChatUI::layout:survey:show", function( ){this._chatTabState = CP_CONST.CHAT_TAB_STATES.SURVEY_WINDOW;}, this);
                this.listenTo(cVent, "cpChatUI::layout:chat:show", function(options ){
                    this._chatInitiated = this._chatInitiated || options && options.initSource || CP_CONST.CHAT_INITIATED_SOURCE.USER;
                    this._chatTabState = CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW;}, this);
                this.listenTo(cVent, "chat:chatTabActivated", this._setOpenChatRead);
                this.listenTo(LEConnection.vent, 'chat:notifications:accumulatedChanged', this._updateChatNotificationsCounter);
                this.listenTo(cVent, 'chat:notifications:ChatTabActivated_OngoingChat', this._maybeResetChatCounter);
                this.listenTo(this._contextModel, 'change:isOpen', function( ){this._maybeResetChatCounter(this._currentChatSkill);});
            },

            onClose: function () {
                this._reset();
            },

            _handleNewChatMessage: function (skillName, increment) {

                logger.debug("entered NotificationController:_handleNewChatMessage", skillName, increment);
                var isChatTabActive = this._contextModel.get("selectedTab") === CP_CONST.TABS.CHAT;
                var isChatWindowForeGround = this._chatTabState === CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW;
                var isChatIframeState = this._iframeState === CP_CONST.CONVERSATION_IFRAME_STATE.CHAT;
                var isCPOpen = this._contextModel.isOpen();
                var isChatting = this._chatChannel.reqres.request("chatInfo::request:isChatting");
                var isChatResumed = this._chatInitiated === CP_CONST.CHAT_INITIATED_SOURCE.RESUME;

                if (!isChatting) {
                    this._resetChatCounter(this._currentChatSKill);
                    return;
                }
                logger.debug("NotificationController._handleNewChatMessage", isChatTabActive, isChatWindowForeGround);
                if (!isCPOpen || !isChatTabActive || !isChatWindowForeGround || !isChatIframeState) {
                    logger.info("trigger chat notification counter increment", isChatTabActive, isChatWindowForeGround);

                    if (isChatResumed) {
                        this._currentChatSkill = this._currentChatSkill || skillName;
                        this._chatInitiated = 1;
                    }
                    this._chatChannel.vent.trigger("chat:notifications:incrementCounter", skillName, increment, isChatResumed);
                }


            },

            _handleNewMessagingMessage: function (model, message, agentModel) {
                var isCPOpen = this._contextModel.isOpen();
                var isAgentNameSet = agentModel.has("nickname");
                if (!isCPOpen && isAgentNameSet) {
                    var desktopNotification = this._createDesktopNotification(model, message, agentModel);
                    agentLEManager.notificationCenterNotify(desktopNotification);
                }
            },

            _createDesktopNotification: function (model, message, agentModel) {
                var desktopNotification,
                    agentName = agentModel.get("nickname");

                desktopNotification = {
                    DesktopNotification: {
                        title: agentName,
                        body: message,
                        iconUrl: "src/modules/connection/assets/img/incoming-message-LP.png",
                        onClick: _.bind(this._openMessagingConversation, this, model)
                    }
                };
                return desktopNotification;
            },

            _openMessagingConversation: function (model) {
                this._contextModel.setIsOpen(true);
                this._chatChannel.vent.trigger('chat:start:request', {model: model});
            },

            _maybeResetChatCounter: function (skillName){
                var isChatTabActive = this._contextModel.get("selectedTab") === CP_CONST.TABS.CHAT;
                var isChatWindowForeGround = this._chatTabState === CP_CONST.CHAT_TAB_STATES.CHAT_WINDOW;
                var isChatIframeState =  this._iframeState === CP_CONST.CONVERSATION_IFRAME_STATE.CHAT;

                logger.debug("ChatNotificationController._maybeResetChatCounter", isChatTabActive, isChatWindowForeGround);
                if(isChatWindowForeGround && isChatTabActive && isChatIframeState){
                    this._chatChannel.vent.trigger("chat:notifications:resetCounter", skillName);
                }
            },

            _resetChatCounter: function (skillName){
                logger.debug("ChatNotificationController._resetChatCounter", skillName);
                this._chatChannel.vent.trigger("chat:notifications:resetCounter", skillName);
            },

            _updateChatNotificationsCounter: function(counter) {
                logger.debug("ChatNotificationController._updateChatNotificationsCounter");
                LEConnection.contextModel.set("chatNotificationsCounter", counter);
                LEConnection.contextModel.set("chatIsActive", counter>0);
            }
        });
    });
    return ChatNotificationsController;
});
